export default __webpack_public_path__ + "static/media/@rebeccafolly.bb13d7cf.jpg";